import { render, staticRenderFns } from "./BoardComments.vue?vue&type=template&id=7b5d9368&"
import script from "./BoardComments.vue?vue&type=script&lang=js&"
export * from "./BoardComments.vue?vue&type=script&lang=js&"
import style0 from "./BoardComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports